import React, { useState } from 'react';
import { Modal, Select } from 'antd';

interface OrphanOwner {
  uid: string;
  name: string;
  ofName: string; // "de Marie Dupont", "d'un compte supprimé"
  count: number;
}

interface AttachOrphansModalProps {
  /** Member whose orphan contacts are put back, null when closed */
  owner: OrphanOwner | null;
  /** Numbers someone holds: their holder becomes the owner of the contacts */
  targets: { value: string; label: string; name: string }[];
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: (ownerUid: string, subscriptionId: string) => void;
}

const AttachOrphansModal: React.FC<AttachOrphansModalProps> = ({ owner, targets, isLoading, onCancel, onConfirm }) => {
  const [subscriptionId, setSubscriptionId] = useState<string | undefined>(undefined);
  const target = targets.find((option) => option.value === subscriptionId);

  const handleCancel = () => {
    setSubscriptionId(undefined);
    onCancel();
  };

  return (
    <Modal
      open={!!owner}
      title={owner ? `Rattacher les contacts ${owner.ofName}` : ''}
      okText="Rattacher"
      cancelText="Annuler"
      okButtonProps={{ disabled: !subscriptionId }}
      confirmLoading={isLoading}
      onCancel={handleCancel}
      onOk={() => owner && subscriptionId && onConfirm(owner.uid, subscriptionId)}
      afterClose={() => setSubscriptionId(undefined)}
      centered
    >
      <Select
        style={{ width: '100%' }}
        placeholder="Choisir un numéro"
        showSearch
        optionFilterProp="label"
        value={subscriptionId}
        onChange={setSubscriptionId}
        options={targets.map((option) => ({ value: option.value, label: `${option.label} (${option.name})` }))}
      />
      {owner && target && (
        <p style={{ marginTop: 12, marginBottom: 0 }}>
          {owner.count} contact{owner.count > 1 ? 's' : ''} et {owner.count > 1 ? 'leur' : 'son'} historique passeront
          à <strong>{target.label}</strong>.
        </p>
      )}
    </Modal>
  );
};

export default AttachOrphansModal;